import React from "react";
import { MEDIA_URL } from "../../config/url";
// import "../../assets/css/banner.css";
// import Swiper core and required modules
import {
  Navigation,
  Pagination,
  Scrollbar,
  A11y,
  Autoplay,
} from "swiper/modules";

import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import "../../assets/css/banner.css";
import { useMediaQuery, useTheme } from "@mui/material";
import { useNavigate } from "react-router-dom";

const Banner = ({ bannertable, fetchingDashbboard }) => {
  console.log(bannertable);
  const theme = useTheme();
  const navigate = useNavigate();
  const matchesSM = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <section className="masthead -type-7">
      {!matchesSM ? (
        <Swiper
          className="main-swiper"
          spaceBetween={50}
          slidesPerView={1}
          navigation
          pagination={{ clickable: true }}
          scrollbar={{ draggable: true }}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
          }}
          loop={true}
          loopFillGroupWithBlank={true}
          modules={[Pagination, Navigation, Autoplay]}
        >
          {fetchingDashbboard ? (
            <SwiperSlide>
              {" "}
              <div className="skeleton-loader"></div>{" "}
            </SwiperSlide>
          ) : (
            bannertable.map((banner, index) => (
              <SwiperSlide
                key={index}
                onClick={() => {
                  if (banner.URL) {
                    console.log("clicked");
                    // navigate("/results");
                    window.open("/results", "_blank");
                  }
                }}
              >
                <div className="row justify-center text-center">
                  <div className="col-auto">
                    <div className="masthead__content">
                      <div className="masthead__bg">
                        <img
                          src={`${MEDIA_URL}${banner.Image_Path}`}
                          alt={banner.Banner_Title}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))
          )}
        </Swiper>
      ) : (
        <Swiper
          className="main-swiper"
          spaceBetween={50}
          slidesPerView={1}
          navigation
          pagination={{ clickable: true }}
          scrollbar={{ draggable: true }}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
          }}
          loop={true}
          loopFillGroupWithBlank={true}
          modules={[Pagination, Navigation, Autoplay]}
        >
          {fetchingDashbboard ? (
            <SwiperSlide>
              {" "}
              <div className="skeleton-loader"></div>{" "}
            </SwiperSlide>
          ) : (
            bannertable.map((banner, index) => (
              <SwiperSlide
                key={index}
                onClick={() => {
                  if (banner.URL) {
                    console.log("clicked");
                    // navigate("/results");
                    window.open("/results", "_blank");
                  }
                }}
              >
                <div className="row justify-center text-center">
                  <div className="col-auto">
                    <div className="masthead__content">
                      <div className="masthead__bg">
                        <img
                          src={`${MEDIA_URL}${banner.Mobile_Image_Path}`}
                          alt={banner.Banner_Title}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))
          )}
        </Swiper>
      )}
    </section>
  );
};

export default Banner;

{
  /* <div
              className="swiper-slide swiper-slide-duplicate swiper-slide-prev"
              data-swiper-slide-index="2"
              role="group"
              aria-label="3 / 3"
              //   style="width: 1349px;"
              style={{ width: "1349px" }}
            >
              <div className="row justify-center text-center">
                <div className="col-auto">
                  <div className="masthead__content">
                    <div className="masthead__bg">
                      <img
                        src="https://fitizenindia.com/uploads/settings/default_slider_image_1_1693192552.jpg"
                        alt="example"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div> */
}
